import React, { createRef } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";

import { Grid, Dialog, IconButton } from "@material-ui/core";
import { Images } from "config/images";

const DialogInformation = props => {
	const classes = useStyles();
	const { isSuccess, handleClose, open, message, handleSubmit } = props;
	const nodeRef = createRef();

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			ref={nodeRef}
			fullWidth
		>
			<Grid>
				<Grid classes={{ root: classes.closeButton }}>
					<IconButton aria-label="close" onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
				<Grid classes={{ root: classes.body }}>
					<img
						src={
							isSuccess
								? Images.icGiftSuccess
								: Images.icGiftError
						}
						alt={isSuccess ? "icGiftSuccess" : "icGiftError"}
						width={72}
					/>
					<Grid classes={{ root: classes.title }}>
						{isSuccess ? "Đổi quà thành công" : "Đổi quà thất bại"}
					</Grid>
					{message && (
						<Grid classes={{ root: classes.subTitle }}>
							{message}
						</Grid>
					)}
					<Grid classes={{ root: classes.driver }} />
					<Grid
						classes={{ root: classes.btnSubmit }}
						onClick={() => handleSubmit(isSuccess)}
					>
						{isSuccess ? "Tiếp tục" : "Thử lại"}
					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};

export default DialogInformation;
